module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"yLabelDemand":"Strombedarf (kWh/m²)","yLabelProduction":"Stromproduktion (kWh/m²)","yLabelAbsoluteProduction":"Stromproduktion (MWh)","ownUseLabel":"Eigenverbrauch","gridLabel":"Stromnetz","feedinLabel":"Netzrückspeisung","total":"Total"}}')
  delete Component.options._Ctor
}
